import {
    OBTENER_WSGSTATUS,
    OBTENER_WSGSTATUS_EXITO,
    OBTENER_WSGSTATUS_ERROR
} from "../../redux/types";
import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";

// Función que descarga los wsg_status de la base de datos
export function obtenerWsgStatusAction() {
  return async (dispatch) => {
    dispatch(descargarWsgStatus());
    await clienteAxios
      .get(`/buscar?coleccion=wsg_status&variable=codigo&termino=TODOS`)
      .then((respuesta) => {
        dispatch(
          descargaWsgStatusExitosa(respuesta.data)
        );
      })
      .catch((err) => {
        dispatch(descargaWsgStatusError(handlerError(err)));
      });
  };
}

const descargarWsgStatus = () => ({
  type: OBTENER_WSGSTATUS,
  payload: true,
});

const descargaWsgStatusExitosa = (pedidos) => ({
  type: OBTENER_WSGSTATUS_EXITO,
  payload: pedidos,
});

const descargaWsgStatusError = (error) => ({
  type: OBTENER_WSGSTATUS_ERROR,
  payload: error,
});